import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from "react-i18next";
//api
import { getLocalities } from 'api/company';
//components
import AutoCompleteInput from './autoCompleteInput';

const SearchLocality = ({ 
  filterBy, 
  onSelected, 
  placeholder, 
  defaultLocality = null 
}) => {
  const { t } = useTranslation(['backoffice']);
  const [localitySelected, setLocalitySelected] = useState(null);

  useEffect(() => {
    if (defaultLocality) {
      setLocalitySelected({
        label: defaultLocality[filterBy],
        value: defaultLocality.id,
      });
    } else setLocalitySelected(null)
  }, [defaultLocality]);

  const onSearch = async (value) => {
    if (value.length > 1) {
      const { status, data } = await getLocalities({ 
        [filterBy]: value, 
        page: 1, 
        page_size: 10 
      });
      if (status === 200) {
        return data?.results?.map((item) => ({
          ...item,
          label: item["nombre"] + " (" + item["cod_postal"] + ")",
          value: item.id,
        }));
      }
    }
    return [];
  };

  return (
    <AutoCompleteInput
      label={t('localidad')}
      placeholder={placeholder}
      defaultOptions={localitySelected ? [localitySelected] : []}
      defaultValue={localitySelected}
      onSelect={onSelected}
      onSearch={onSearch}
    />
  );
};

SearchLocality.propTypes = {
  filterBy: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  onSelected: PropTypes.func.isRequired,
  defaultLocality: PropTypes.any,
};

export default SearchLocality;
